var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row-customer row-customer--skeleton" }, [
      _c("div", { staticClass: "row-customer__content" }, [
        _c("div", { staticClass: "row-customer--left" }, [
          _c("div", { staticClass: "skeleton skeleton-icon" }),
          _c("div", { staticClass: "skeleton skeleton-title" }),
          _c("div", { staticClass: "skeleton skeleton-count" })
        ]),
        _c("div", { staticClass: "row-customer__summary" }, [
          _c("div", { staticClass: "skeleton skeleton-summary" }),
          _c("div", { staticClass: "skeleton skeleton-summary" })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }